module.exports = __webpack_public_path__ + "img/ws.4ca34940.svg";